import { List } from '../../../List';
import { TableFeaturesHeader, TableFeaturesItem } from './';

/**
 * TableFeaturesAndTips component
 * Used to display a list of table features and tips with a header in descriptive cards above the Kendo Tables.
 * 
 * Create an array using the TABLE_TIPS object found in this directory depending on what features your Kendo table uses (e.g., filtering, sorting, exporting).
 * Then pass that array as the `tips` prop to this component.
 * 
 * @param {Object} params - The parameters object.
 * @param {Array} params.tips - An array of tip objects to be displayed in the list.
 * 
 * @returns {JSX.Element} The rendered TableFeaturesAndTips component.
 */
export const TableFeaturesAndTips = ({ tips }) => (
    <List
        header={TableFeaturesHeader}
        data={tips}
        item={({ dataItem }) => <TableFeaturesItem dataItem={dataItem} />}
    />
);